// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { FoldersInstance } from "./helpers/foldersInstanceHelpers";
import { createFoldersInstance } from "./helpers/foldersInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, FoldersInstance>({
	name: "Folders",
	createBase: createBaseNotary,
	createInstance: createFoldersInstance,
});

export function getFoldersInstance(): FoldersInstance {
	return factory.getInstance();
}
